import { SaveButton } from "components/Buttons"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { hideDeletePendingUsersModal } from "store/actions"

const DeletePendingUsersModal = ({
  selectedUsers,
  hideDeletePendingUsersModal,
  loading,
  handleDeletePendingUsers,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <p>
            {selectedUsers?.length} users are selected, only the Pending ones
            will be deleted.
          </p>
          <p>
            Are you sure that you want to do this? <br />
            This action can not be undone.
          </p>
        </Col>
      </Row>

      <Row className="justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideDeletePendingUsersModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Delete"
            onClick={handleDeletePendingUsers}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  loading: state.people.loading,
})

const mapDispatchToProps = dispatch => ({
  hideDeletePendingUsersModal: () => dispatch(hideDeletePendingUsersModal()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePendingUsersModal)
